import CIVIL_GUARANTEES from './seed/CIVIL_GUARANTEES.json';
import CIVIL from './seed/CIVIL.json';
import CIVIL_SITE_COORDS from './seed/CIVIL_SITE_COORDS.json';
import COE_OPERATIONAL_DEFAULT from './seed/COE_OPERATIONAL_DEFAULT.json';
import PROC_COMPLETED from './seed/PROC_COMPLETED.json';
import PROC_ONGOING from './seed/PROC_ONGOING.json';
import PROC_CIVIL from './seed/PROC_CIVIL.json';
import PROC_INPROCESS from './seed/PROC_INPROCESS.json';
import PROC_YET_TO_INITIATE from './seed/PROC_YET_TO_INITIATE.json';
import GAP from './seed/GAP.json';
import GAP_ALERT from './seed/GAP_ALERT.json';
import CM_PIU from './seed/CM_PIU.json';
import CM_COE from './seed/CM_COE.json';
import CM_CONS from './seed/CM_CONS.json';
import CM_NC from './seed/CM_NC.json';
import BUDGET_ROWS from './seed/BUDGET_ROWS.json';
import BUDGET_CHART_COLORS from './seed/BUDGET_CHART_COLORS.json';
import COMPONENT3_CS06 from './seed/COMPONENT3_CS06.json';
import COMPONENT3_MONTHS from './seed/COMPONENT3_MONTHS.json';
import CIVIL_FINANCIAL_MONTHLY from './seed/CIVIL_FINANCIAL_MONTHLY.json';
import CIVIL_CONSULTANT from './seed/CIVIL_CONSULTANT.json';
import COMPONENT3_INNER_TABS from './seed/COMPONENT3_INNER_TABS.json';
import TRAINING_COMPONENT_META from './seed/TRAINING_COMPONENT_META.json';
import TRAINING_PRINCIPALS from './seed/TRAINING_PRINCIPALS.json';
import TRAINING_C1_SEED from './seed/TRAINING_C1_SEED.json';
import TRAINING_C2_SEED from './seed/TRAINING_C2_SEED.json';
import ACCOUNTS from './seed/ACCOUNTS.json';
import type { CivilRow } from '@type/store';
import type { SeedData } from '@type/seed';

export const USD_TO_PKR = 278;

const siteCoords = CIVIL_SITE_COORDS as Record<string, { lat: number; lng: number }>;

export const SEED: SeedData = {
  CIVIL: (CIVIL as CivilRow[]).map((c) => {
    const site = String(c.site ?? '');
    const coords = siteCoords[site];
    return coords ? { ...c, lat: coords.lat, lng: coords.lng } : { ...c };
  }),
  COE_OPERATIONAL: (COE_OPERATIONAL_DEFAULT as CivilRow[]).map((c) => ({ ...c })),
  PROC_COMPLETED,
  PROC_ONGOING,
  PROC_CIVIL,
  PROC_INPROCESS,
  PROC_YET_TO_INITIATE,
  GAP: GAP.map((g) => ({ ...g })),
  GAP_ALERT: { ...GAP_ALERT },
  CM: { piu: CM_PIU, coe: CM_COE, cons: CM_CONS, nc: CM_NC },
  BUDGET_ROWS: BUDGET_ROWS.map((r) => ({ ...r })),
  BUDGET_CHART_COLORS,
  COMPONENT3_CS06: JSON.parse(JSON.stringify(COMPONENT3_CS06)),
  COMPONENT3_MONTHS,
  CIVIL_FINANCIAL_MONTHLY,
  CIVIL_GUARANTEES,
  CIVIL_CONSULTANT: { ...CIVIL_CONSULTANT },
  COMPONENT3_INNER_TABS,
  TRAINING_COMPONENT_META,
  TRAINING_PRINCIPALS,
  TRAINING_BY_COMPONENT: {
    1: TRAINING_C1_SEED.map((r) => ({ ...r })),
    2: TRAINING_C2_SEED.map((r) => ({ ...r })),
    3: [],
  },
  ACCOUNTS: JSON.parse(JSON.stringify(ACCOUNTS)),
};
